import { render, staticRenderFns } from "./addCom.vue?vue&type=template&id=1c2cf807&scoped=true&"
import script from "./addCom.vue?vue&type=script&lang=js&"
export * from "./addCom.vue?vue&type=script&lang=js&"
import style0 from "./addCom.vue?vue&type=style&index=0&id=1c2cf807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cf807",
  null
  
)

export default component.exports